var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import AlertCard from '@/components/alert-card/AlertCard';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { Event } from '@/models/Event';
import { Group } from '@/models/Group';
import { Student } from '@/models/Student';
import { User } from '@/models/User';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { blackKidIcons, lessonTypeIcons } from '@/support/Icon';
import { sortByKey } from '@/support/Object';
import { replaceUrlsWithAnchorTags } from '@/support/String';
import { DateTime } from 'luxon';
import { Component, Prop, Watch } from 'vue-property-decorator';
import RosterEditDialog from '@/components/roster-edit-dialog/RosterEditDialog';
import { Template } from '@/models/Template';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import { RolesEnum } from '@/items/Roles';
import GroupsAutocomplete from '@/components/Autocompletes/GroupsAutocomplete/GroupsAutocomplete';
import AbstractUrl from '@/support/AbstractUrl';
let Roster = class Roster extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.selectedUser = null;
        this.isLoading = false;
        this.selectedDay = DateTime.local();
        this.userSubjects = null;
        this.selectedEvent = null;
        this.week = [];
        this.selectedGroups = [];
        this.statusColorMap = {
            highlighted: '#f8c623',
            busy: '#008ac4',
            old: '#ff7800',
            inactive: '#9b9b9b',
            closed: '#d0021b',
            finished: '#00b900',
        };
        this.isShowingLessonDialog = false;
        this.isEditingEvent = false;
        this.isShowingEditSubjectDialog = false;
        this.subjectTarget = null;
        this.student = null;
        this.templates = [];
        this.selectedLesson = null;
        this.expanded = {};
        this.lessons = [];
        this.teachingUser = new User;
        this.teachingGroup = new Group;
        this.day = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
            7: [],
            8: [],
            9: [],
            10: [],
            11: [],
            12: [],
            13: [],
            14: [],
            15: [],
            16: [],
            17: [],
            18: [],
            19: [],
            20: [],
            21: [],
            22: [],
            23: [],
        };
    }
    created() {
        if (this.$route.query && this.$route.query.groups) {
            const groups = this.$route.query.groups;
            this.selectedGroups = Array.isArray(groups) ? groups : [groups];
        }
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.relationships.length === 1 ? this.getSelectedUser(this.relationships[0].user.id) : '';
        const eventUser = this.createEventUser(this.user);
        this.buildWeek(DateTime.local());
        this.getSchedule(eventUser);
    }
    getAppendIcon() {
        if (this.user && this.selectedUser && this.user.id !== this.selectedUser.value) {
            return 'cancel';
        }
        return null;
    }
    isStudentUser(eventUser) {
        if (!eventUser.roles) {
            return false;
        }
        const role = eventUser.roles.find((role) => {
            return role.name.toLowerCase() === 'student';
        });
        if (role) {
            return true;
        }
        return false;
    }
    createEventUser(user) {
        return {
            text: `${user.getFilterLabel()}`,
            value: user.resolvePrimaryKey(),
            roles: user.roles,
        };
    }
    setSelectedUser() {
        this.selectedUser = {
            text: 'this.user.getFilterLabel()',
            value: this.user.resolvePrimaryKey(),
            roles: this.user.roles,
        };
    }
    getSelectedUser(userId) {
        new User()
            .include(['roles'])
            .find(userId)
            .then((user) => {
            const eventUser = this.createEventUser(user);
            this.selectedUser = eventUser;
            this.getSchedule(eventUser);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    onSaveBookmark() {
        this.$emit('save-bookmark', window.location.href);
        // comunicate to bookmarks
    }
    getTeachingUser(lesson) {
        this.teachingUser = lesson.teacher;
    }
    getSchedule(eventUser) {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        this.lessons = [];
        this.emptyDay();
        const today = this.selectedDay.toFormat('yyyy-LL-dd');
        let filter = { starts: today, ends: today, types: ['lesson', 'recess'] };
        if ((!this.selectedGroups || !this.selectedGroups.length) && eventUser) {
            filter = { ...filter, ...{ users: [eventUser.value] } };
        }
        if (this.isStudentUser(eventUser)) {
            filter = { ...filter, ...{ is_chosen: true } };
            this.getUserSubjects(eventUser);
        }
        if (this.selectedGroups) {
            filter.groups = this.selectedGroups;
            this.setQueryParams({ groups: this.selectedGroups });
        }
        new Event()
            .filter(filter)
            .include(['areas', 'topics', 'room', 'subject', 'subjects', 'meta', 'lesson_type', 'parent', 'levels', 'period', 'teacher', 'roles', 'groups', 'datetimeslots'])
            .all()
            .then((events) => {
            this.lessons = events;
            this.sortSchedule();
            this.isLoading = false;
        });
    }
    getUserSubjects(eventUser) {
        new UserSubject()
            .user(eventUser.value)
            .limit(1000)
            .all()
            .then((userSubjects) => {
            this.userSubjects = userSubjects;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getSubjectStatus(subject) {
        if (!this.userSubjects || !subject) {
            return 'inactive';
        }
        const userSubject = this.userSubjects.find((userSubject) => {
            return subject.id === userSubject.subject;
        });
        if (!userSubject) {
            return 'inactive';
        }
        return userSubject.status || 'inactive';
    }
    hasEventStarted(lesson) {
        const startsAt = DateTime.fromSQL(lesson.starts_at || '');
        if (!startsAt.isValid) {
            return true;
        }
        return DateTime.local() > DateTime.fromSQL(lesson.starts_at || '');
    }
    getUserSubject(subject) {
        if (!this.userSubjects) {
            return null;
        }
        const foundSubject = this.userSubjects.find((userSubject) => {
            return subject.id === userSubject.subject;
        });
        return foundSubject || null;
    }
    getUserSubjectId(subject) {
        if (!this.userSubjects) {
            return '';
        }
        const userSubject = this.userSubjects.find((userSubject) => {
            return subject.id === userSubject.subject;
        });
        if (userSubject) {
            return userSubject.id;
        }
        return '';
    }
    sortSchedule() {
        this.lessons.sort(sortByKey('starts_at'));
        const expanded = {};
        this.lessons.forEach((lesson) => {
            expanded[lesson.id || ''] = false;
            if (lesson.starts_at) {
                const startHour = DateTime.fromSQL(lesson.starts_at).hour;
                if (this.day[startHour]) {
                    this.day[startHour].push(lesson);
                }
                else {
                    this.day[startHour] = [lesson];
                }
            }
            this.getTeachingUser(lesson);
        });
        this.expanded = { ...expanded, ...this.expanded };
    }
    emptyDay() {
        Object.keys(this.day).forEach((key) => {
            this.day[parseInt(key)] = [];
        });
    }
    getStatusPillStyles(subject, student) {
        const status = this.getSubjectStatus(subject);
        const color = this.statusColorMap[status] || '#000';
        return { backgroundColor: `${color}` };
    }
    isActiveDay(day) {
        if (day.toFormat('yyyy-LL-dd') === this.selectedDay.toFormat('yyyy-LL-dd')) {
            return true;
        }
        return false;
    }
    setActiveDay(day) {
        if (!this.selectedUser) {
            this.setSelectedUser();
        }
        this.selectedDay = day;
        if (this.selectedUser) {
            this.getSchedule(this.selectedUser);
        }
    }
    date(key) {
        return DateTime.fromSQL(key);
    }
    subjectIcon(key) {
        key = key || 'others';
        return blackKidIcons[key];
    }
    lessonTypeIcon(key) {
        key = key || '';
        return lessonTypeIcons[key];
    }
    resetSchedule() {
        this.initialize();
    }
    async onClickOpenEditSubjectDialog(subject) {
        if (!this.userSubjects || !subject.id) {
            return;
        }
        const userSubject = this.userSubjects.find((userSubject) => {
            return subject.id === userSubject.subject;
        });
        if (!userSubject) {
            return;
        }
        this.subjectTarget = userSubject;
        if (['dismissed', 'future'].includes(this.subjectTarget && this.subjectTarget.status || '')) {
            return;
        }
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(userSubject.id || '');
        }
        await this.getStudentByUserId(this.user.id || '');
        if (this.student) {
            this.isShowingEditSubjectDialog = true;
        }
    }
    async getTemplates(subjectId) {
        // console.log('get templates fired', subjectId);
        try {
            this.templates = await new Template()
                .subject(subjectId)
                .include('file')
                .all();
        }
        catch (error) {
            //
        }
    }
    async getStudentByUserId(userId) {
        try {
            this.student = await new Student().find(userId);
        }
        catch (error) {
            //
        }
    }
    subjectStatusLabel(subject) {
        if (!this.userSubjects) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        let status = 'inactive';
        const userSubject = this.userSubjects.find((userSubject) => {
            return userSubject.subject === subject.id;
        });
        if (userSubject && userSubject.status) {
            status = userSubject.status;
        }
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    handleEventEditted() {
        this.initialize();
    }
    openLessonDialog(lesson) {
        this.selectedEvent = lesson;
        this.isEditingEvent = true;
    }
    changeWeek(type) {
        this.week = [];
        if (type === 'next') {
            this.selectedDay = this.selectedDay.plus({ days: 7 });
        }
        else {
            this.selectedDay = this.selectedDay.minus({ days: 7 });
        }
        this.buildWeek(this.selectedDay);
        const eventUser = this.selectedUser ? this.selectedUser : this.createEventUser(this.user);
        this.getSchedule(eventUser);
    }
    buildWeek(day) {
        const dayNumber = parseInt(day.toFormat('c'));
        const week = [];
        for (let i = 1; i <= 5; i += 1) {
            const diff = i - dayNumber;
            const date = day.plus({ days: diff });
            week.push(date);
        }
        this.week = week;
    }
    getEventSubjectOverviewUrl(event) {
        let url = `/events/${event.id}/subjects?event=${event.id}&area=${event && event.areas && event.areas[0] ? event.areas[0].id : ''}`;
        const levels = event.levels ? event.levels.map((level) => level.id) : [];
        url += `&levels=${levels.join(',')}`;
        return url;
    }
    parseEventDescription(description) {
        return replaceUrlsWithAnchorTags(description);
    }
    selectedUserChanged(newValue, oldValue) {
        if (newValue && newValue.value) {
            if (!oldValue || newValue.value !== oldValue.value) {
                this.getSelectedUser(newValue.value);
            }
        }
    }
    onSelectedGroupChanged(newValue, oldValue) {
        this.getSchedule(this.selectedUser || this.createEventUser(this.user));
    }
};
__decorate([
    Prop({ default: new User() }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], Roster.prototype, "user", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], Roster.prototype, "relationships", void 0);
__decorate([
    Watch('selectedUser'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Roster.prototype, "selectedUserChanged", null);
__decorate([
    Watch('selectedGroups'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Roster.prototype, "onSelectedGroupChanged", null);
Roster = __decorate([
    Component({
        components: {
            AlertCard,
            AsyncSelect,
            LoaderCard,
            RosterEditDialog,
            EditSubjectDialog,
            GroupsAutocomplete,
        },
    })
], Roster);
export default Roster;
